import { render, staticRenderFns } from "./sellflow.vue?vue&type=template&id=896481b4&scoped=true"
import script from "./sellflow.vue?vue&type=script&lang=js"
export * from "./sellflow.vue?vue&type=script&lang=js"
import style0 from "./sellflow.vue?vue&type=style&index=0&id=896481b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896481b4",
  null
  
)

export default component.exports